var map = {
	"./": 31,
	"./App": 38,
	"./App.tsx": 38,
	"./assets/images/Group 1.svg": 106,
	"./assets/images/HeroSVG.svg": 107,
	"./assets/images/Tax.svg": 108,
	"./assets/images/accounting copy": 86,
	"./assets/images/accounting copy.tsx": 86,
	"./assets/images/book.svg": 109,
	"./assets/images/calculator.svg": 110,
	"./assets/images/chart.svg": 111,
	"./assets/images/chevron/down-chevron.svg": 112,
	"./assets/images/chevron/up-chevron.svg": 113,
	"./assets/images/clientsLogo/AndrlaAvatar.jpg": 114,
	"./assets/images/clientsLogo/AndrlaLogo.jpg": 74,
	"./assets/images/clientsLogo/NFPNLogo.jpg": 78,
	"./assets/images/clientsLogo/OpametalLogo.png": 115,
	"./assets/images/clientsLogo/OpametalMainLogo.jpg": 77,
	"./assets/images/clientsLogo/SpiralaLogo.png": 79,
	"./assets/images/clientsLogo/SpiralaLogo2.png": 116,
	"./assets/images/clientsLogo/logo ANIMA.png": 75,
	"./assets/images/clientsLogo/logo OOS.jpg": 76,
	"./assets/images/clientsLogo/logo_kdp-PNG.png": 117,
	"./assets/images/education.svg": 118,
	"./assets/images/money.svg": 119,
	"./assets/images/pavla.png": 73,
	"./assets/images/salary (1).svg": 120,
	"./assets/images/salary.svg": 121,
	"./assets/images/svgAssets/AccountingSvg": 44,
	"./assets/images/svgAssets/AccountingSvg.tsx": 44,
	"./assets/images/svgAssets/EducationSvg": 45,
	"./assets/images/svgAssets/EducationSvg.tsx": 45,
	"./assets/images/svgAssets/MoneySvg": 87,
	"./assets/images/svgAssets/MoneySvg.tsx": 87,
	"./assets/images/svgAssets/SalarySvg": 46,
	"./assets/images/svgAssets/SalarySvg.tsx": 46,
	"./assets/images/svgAssets/TaxSvg": 47,
	"./assets/images/svgAssets/TaxSvg.tsx": 47,
	"./assets/localization/cs_CZ": 21,
	"./assets/localization/cs_CZ.json": 21,
	"./assets/logo_kdp-PNG.png": 28,
	"./assets/logo_kdp-jpg.jpg": 122,
	"./assets/variables.css": 83,
	"./components/Accordeon/Accordeon": 48,
	"./components/Accordeon/Accordeon.tsx": 48,
	"./components/Accordeon/accordeon.styles.css": 68,
	"./components/Accordeon/components/AccordeonItem": 49,
	"./components/Accordeon/components/AccordeonItem.tsx": 49,
	"./components/Button": 32,
	"./components/Button/": 32,
	"./components/Button/button.styles": 50,
	"./components/Button/button.styles.ts": 50,
	"./components/Button/enum": 30,
	"./components/Button/enum.tsx": 30,
	"./components/Button/index": 32,
	"./components/Button/index.tsx": 32,
	"./components/Card": 16,
	"./components/Card/": 16,
	"./components/Card/Card": 33,
	"./components/Card/Card.tsx": 33,
	"./components/Card/components/StyledCardDetail": 53,
	"./components/Card/components/StyledCardDetail.ts": 53,
	"./components/Card/components/StyledCardList": 52,
	"./components/Card/components/StyledCardList.ts": 52,
	"./components/Card/components/StyledContentWrapper": 54,
	"./components/Card/components/StyledContentWrapper.ts": 54,
	"./components/Card/components/card.styles": 51,
	"./components/Card/components/card.styles.ts": 51,
	"./components/Card/index": 16,
	"./components/Card/index.tsx": 16,
	"./components/Carousel/Carousel": 17,
	"./components/Carousel/Carousel.tsx": 17,
	"./components/Carousel/styles.css": 84,
	"./components/Citation": 15,
	"./components/Citation/": 15,
	"./components/Citation/components/StyledAvatar": 26,
	"./components/Citation/components/StyledAvatar.ts": 26,
	"./components/Citation/components/StyledCitation": 42,
	"./components/Citation/components/StyledCitation.ts": 42,
	"./components/Citation/components/Wrapper": 43,
	"./components/Citation/components/Wrapper.ts": 43,
	"./components/Citation/index": 15,
	"./components/Citation/index.tsx": 15,
	"./components/Counter": 23,
	"./components/Counter/": 23,
	"./components/Counter/counter.styles": 55,
	"./components/Counter/counter.styles.ts": 55,
	"./components/Counter/index": 23,
	"./components/Counter/index.tsx": 23,
	"./components/Hero": 22,
	"./components/Hero/": 22,
	"./components/Hero/components/StyledImage": 29,
	"./components/Hero/components/StyledImage.ts": 29,
	"./components/Hero/hero.styles": 27,
	"./components/Hero/hero.styles.ts": 27,
	"./components/Hero/index": 22,
	"./components/Hero/index.tsx": 22,
	"./components/Map": 24,
	"./components/Map/": 24,
	"./components/Map/index": 24,
	"./components/Map/index.tsx": 24,
	"./components/Navbar/Navbar": 56,
	"./components/Navbar/Navbar.tsx": 56,
	"./components/Navbar/components/NavbarLogo": 59,
	"./components/Navbar/components/NavbarLogo.tsx": 59,
	"./components/Navbar/components/StyledLink": 18,
	"./components/Navbar/components/StyledLink.tsx": 18,
	"./components/Navbar/components/StyledList": 57,
	"./components/Navbar/components/StyledList.tsx": 57,
	"./components/Navbar/components/StyledNavbar": 58,
	"./components/Navbar/components/StyledNavbar.tsx": 58,
	"./components/Paper": 14,
	"./components/Paper/": 14,
	"./components/Paper/index": 14,
	"./components/Paper/index.tsx": 14,
	"./components/Paper/paper.styles": 25,
	"./components/Paper/paper.styles.ts": 25,
	"./components/Title": 11,
	"./components/Title/": 11,
	"./components/Title/index": 11,
	"./components/Title/index.tsx": 11,
	"./components/Title/title.styles": 10,
	"./components/Title/title.styles.ts": 10,
	"./index": 31,
	"./index.tsx": 31,
	"./react-app-env.d": 91,
	"./react-app-env.d.ts": 91,
	"./utils/global.styles": 39,
	"./utils/global.styles.ts": 39,
	"./utils/hooks/useWindowSize": 12,
	"./utils/hooks/useWindowSize.ts": 12,
	"./utils/wrapper.styles": 13,
	"./utils/wrapper.styles.tsx": 13,
	"./views/sections/aboutUsSection/AboutUsSection": 40,
	"./views/sections/aboutUsSection/AboutUsSection.tsx": 40,
	"./views/sections/clientsSection/ClientsSection": 41,
	"./views/sections/clientsSection/ClientsSection.tsx": 41,
	"./views/sections/contactsSection/ContactsSection": 60,
	"./views/sections/contactsSection/ContactsSection.tsx": 60,
	"./views/sections/contactsSection/components/StyledContractsDetail": 61,
	"./views/sections/contactsSection/components/StyledContractsDetail.tsx": 61,
	"./views/sections/counterSection/CounterSection": 62,
	"./views/sections/counterSection/CounterSection.tsx": 62,
	"./views/sections/faqSection/FaqSection": 63,
	"./views/sections/faqSection/FaqSection.tsx": 63,
	"./views/sections/servicesSection/ServiceSection": 64,
	"./views/sections/servicesSection/ServiceSection.tsx": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;